import { useState } from "react";
import RenderEmailTabs from "../RenderEmailTabs";
import EArtworkProjects from "./EArtworkProjects";

export default function EArtworkSidebar({ activeTab, setActiveTab }) {
  /* ******************** All States ************************* */

  /* ******************** All Functions ************************* */

  /* ******************** All UseEffects ************************* */

  return (
    <div className="p-2">
      {/* Top Navigation Tab */}
      <RenderEmailTabs activeTab={activeTab} setActiveTab={setActiveTab} />
      {/* Sidebar Content */}

      {/* ******************** Projects List ************************* */}
      <EArtworkProjects />
    </div>
  );
}
